import React from 'react';
import { ClassicButton, PageTitle } from 'modules/shared-ui/components';
import { formatDate, formatSimpleTime } from 'modules/shared/utils';
import { AppointmentSummaryProps } from './appointment-summary-type';

import styles from './appointment-summary-component.module.css';

export const AppointmentSummary: React.FC<AppointmentSummaryProps> = ({
    id,
    date,
    type,
    location,
    noAppointment = false,
    onModifyButtonClick,
    onCancelButtonClick,
    onBackButtonClick,
}: AppointmentSummaryProps) => {
    return (
        <React.Fragment>
            <div className={styles.rootContainer}>
                <PageTitle title="MES PROCHAINS RENDEZ-VOUS" uppercase centered />
                {!noAppointment ? (
                    <div className={styles.summaryContainer}>
                        <div>{`${formatDate(date)} ${formatSimpleTime(date)} - Ref: ${id}`}</div>
                        <div>{`${type} à ${location}`}</div>

                        <div className={styles.buttonsContainer}>
                            <div>
                                <ClassicButton text="MODIFIER LE RENDEZ-VOUS" onClick={() => onModifyButtonClick(id)} />
                            </div>
                            <div>
                                <ClassicButton text="ANNULER LE RENDEZ-VOUS" onClick={() => onCancelButtonClick(id)} />
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={styles.noApptContainer}>
                        <div>Aucun Rendez-vous.</div>
                        <div className={styles.buttonsContainer}>
                            <ClassicButton text="RETOUR" onClick={onBackButtonClick} />
                        </div>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};
